import { createAction } from 'typesafe-actions'
import { type FacebookAccount } from '@/connect-types/reviews/facebookAccounts.type'
import { type FacebookPage } from '@/connect-types/reviews/facebookPages.type'

export const locationsFacebookAuthorizeAccountRequest = createAction(
  'LOCATIONS_FACEBOOK_AUTHORIZE_ACCOUNT_REQUEST',
  (resolve: any) => (orgId: string, redirectUrl: string, appName: string) =>
    resolve({ orgId, redirectUrl, appName })
)

export const locationsFacebookAuthorizeAccountRequestSuccess = createAction(
  'LOCATIONS_FACEBOOK_AUTHORIZE_ACCOUNT_REQUEST_SUCCESS',
  (resolve: any) => (redirectUrl: string) => resolve({ redirectUrl })
)

export const locationsFacebookAuthorizeAccountRequestFailure = createAction(
  'LOCATIONS_FACEBOOK_AUTHORIZE_ACCOUNT_REQUEST_FAILURE',
  (resolve: any) => (errorResponse: any) => resolve({ error: errorResponse })
)

export const locationsFacebookAccountsRequest = createAction(
  'LOCATIONS_FACEBOOK_ACCOUNTS_REQUEST',
  (resolve: any) => (orgId: string) => resolve({ orgId })
)

export const locationsFacebookAccountsRequestSuccess = createAction(
  'LOCATIONS_FACEBOOK_ACCOUNTS_REQUEST_SUCCESS',
  (resolve: any) => (facebookAccounts: FacebookAccount[]) =>
    resolve({ facebookAccounts })
)

export const locationsFacebookAccountsRequestFailure = createAction(
  'LOCATIONS_FACEBOOK_ACCOUNTS_REQUEST_FAILURE',
  (resolve: any) => (errorResponse: any) => resolve({ error: errorResponse })
)

export const locationsFacebookAccountsPagesRequest = createAction(
  'LOCATIONS_FACEBOOK_ACCOUNTS_PAGES_REQUEST',
  (resolve: any) => (orgId: string, accountId: string) =>
    resolve({ orgId, accountId })
)

export const locationsFacebookAccountsPagesRequestSuccess = createAction(
  'LOCATIONS_FACEBOOK_ACCOUNTS_PAGES_REQUEST_SUCCESS',
  (resolve: any) => (facebookPages: FacebookPage[]) =>
    resolve({ facebookPages })
)

export const locationsFacebookAccountsPagesRequestFailure = createAction(
  'LOCATIONS_FACEBOOK_ACCOUNTS_PAGES_REQUEST_FAILURE',
  (resolve: any) => (errorResponse: any) => resolve({ error: errorResponse })
)

export const updateLocationsFacebookPageRequest = createAction(
  'UPDATE_LOCATIONS_FACEBOOK_ACCOUNTS_PAGES_REQUEST',
  (resolve: any) =>
    (orgId: string, pageId: string, token: string, review_id: string) =>
      resolve({ orgId, pageId, token, review_id })
)

export const updateLocationsFacebookPageRequestSuccess = createAction(
  'UPDATE_LOCATIONS_FACEBOOK_ACCOUNTS_PAGES_REQUEST_SUCCESS',
  (resolve: any) => (page: FacebookPage) => resolve({ page })
)

export const updateLocationsFacebookPageRequestFailure = createAction(
  'UPDATE_LOCATIONS_FACEBOOK_ACCOUNTS_PAGES_REQUEST_FAILURE',
  (resolve: any) => (errorResponse: any) => resolve({ error: errorResponse })
)
